import React from 'react'

import { Heading, HeadingProps } from '../Heading'

export interface TitleProps extends HeadingProps {}

export const Title = (props: TitleProps) => {
  return <Heading as="h1" textTransform="uppercase" fontSize="lg" {...props} />
}

export default Title
